import { render, staticRenderFns } from "./AcceptPolicyDocs.vue?vue&type=template&id=5cda56eb&"
import script from "./AcceptPolicyDocs.vue?vue&type=script&lang=js&"
export * from "./AcceptPolicyDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports